import ManagerLayout from "@/views/Layout/ManagerLayout.vue";
import StudentLayout from "@/views/Layout/StudentLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";
// GeneralViews
import NotFound from "@/views/GeneralViews/NotFoundPage.vue";

// Pages

const Login = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Login.vue");
const Reset = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Reset.vue");
const ManagerMain = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Manager/Main.vue");
const StudentMain = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Student/Main.vue");
const Courses = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Courses/Courses.vue");
const Course = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Courses/Course.vue");
const Tasks = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Courses/Tasks.vue");
const Users = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Manager/Users.vue");
const User = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/UserProfile.vue");
const ChangePwd = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/ChangePwd.vue");
const Classes = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Classes/Classes.vue");
const StudentClasses = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Student/Classes.vue");
const Class = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Classes/Class.vue");
const Lesson = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Classes/Lesson.vue");
const StudentLesson = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Student/Lesson.vue");
const Schedule = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Manager/Schedule.vue");
const StudentSchedule = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Student/Schedule.vue");
const Resources = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Manager/Resources.vue");
const Payments = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Manager/Payments.vue");
const Payment = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Manager/Payment.vue");
const Homework = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Manager/Homework.vue");
const StudentDebt = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Student/Debt.vue");
const StudentHomework = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Student/Homework.vue");
const StudentProfile = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Student/Profile.vue");
const StudentChangePwd = () =>
  import(/* webpackChunkName: "pages" */ "@/views/Pages/Student/ChangePwd.vue");
let profilePages = {
  path: "/profile",
  component: ManagerLayout,
  name: "ProfileMenu",
  children: [
    {
      path: "/profile/:filter/:id?",
      name: "Profile",
      component: User,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/changepwd",
      name: "ChangePassword",
      component: ChangePwd,
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let coursePages = {
  path: "/",
  component: ManagerLayout,
  name: "CoursesMenu",
  redirect: "/courses",
  children: [
    {
      path: "courses/:filter?",
      name: "Courses",
      component: Courses,
      props: true,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    },
    {
      path: "course/:filter/:id?",
      name: "Course",
      props: true,
      component: Course,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    },
    {
      path: "tasks/:id?",
      name: "Tasks",
      props: true,
      component: Tasks,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    }
  ]
};

let classPages = {
  path: "/",
  component: ManagerLayout,
  name: "ClassMenu",
  redirect: "/classes",
  children: [
    {
      path: "classes",
      name: "Classes",
      component: Classes,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    },
    {
      path: "class/:id?",
      name: "Class",
      props: true,
      component: Class,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    },
    {
      path: "lesson/:id?",
      name: "Lesson",
      props: true,
      component: Lesson,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    }
  ]
};

let managerPages = {
  path: "/manager",
  component: ManagerLayout,
  name: "ManagerMenu",
  redirect: "/manager/main",
  children: [
    {
      path: "main",
      name: "ManagerMain",
      component: ManagerMain,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    },
    {
      path: "users/:filter?",
      name: "Users",
      component: Users,
      props: true,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    },
    {
      path: "schedule",
      name: "Schedule",
      component: Schedule,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    },
    {
      path: "resources",
      name: "Resources",
      component: Resources,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    },
    {
      path: "payments",
      name: "Payments",
      component: Payments,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    },
    {
      path: "payment/:id?",
      name: "Payment",
      component: Payment,
      props: true,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    },
    {
      path: "homework",
      name: "Homework",
      component: Homework,
      props: true,
      meta: {
        requiresAuth: true,
        requiresRole: 1
      }
    }
  ]
};

let studentPages = {
  path: "/student",
  component: StudentLayout,
  name: "StudentMenu",
  redirect: "/student/main",
  children: [
    {
      path: "main",
      name: "StudentMain",
      component: StudentMain,
      meta: {
        requiresAuth: true,
        requiresRole: 3
      }
    },

    {
      path: "schedule",
      name: "StudentSchedule",
      component: StudentSchedule,
      meta: {
        requiresAuth: true,
        requiresRole: 3
      }
    },
    {
      path: "lesson/:id?",
      name: "StudentLesson",
      props: true,
      component: StudentLesson,
      meta: {
        requiresAuth: true,
        requiresRole: 3
      }
    },
    {
      path: "classes/:id?",
      name: "StudentClasses",
      props: true,
      component: StudentClasses,
      meta: {
        requiresAuth: true,
        requiresRole: 3
      }
    },
    {
      path: "debt",
      name: "StudentDebt",
      props: true,
      component: StudentDebt,
      meta: {
        requiresAuth: true,
        requiresRole: 3
      }
    },
    {
      path: "homework",
      name: "StudentHomework",
      props: true,
      component: StudentHomework,
      meta: {
        requiresAuth: true,
        requiresRole: 3
      }
    },
    {
      path: "changepwd",
      name: "StudentChangePassword",
      props: true,
      component: StudentChangePwd,
      meta: {
        requiresAuth: true,
        requiresRole: 3
      }
    },
    {
      path: "profile",
      name: "StudentProfile",
      props: true,
      component: StudentProfile,
      meta: {
        requiresAuth: true,
        requiresRole: 3
      }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  redirect: "/login",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/reset/:resetkey?",
      name: "Reset",
      component: Reset,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/logout",
      name: "Logout"
    },
    { path: "*", component: NotFound }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/login",
    name: "LoginPage"
  },
  managerPages,
  studentPages,
  coursePages,
  classPages,
  profilePages,
  authPages
];

export default routes;
